<template>
  <div class="campaign-targeting">
    <div class="step"
         v-if="!selecting">
      <div class="campaign-header">
        <h2 v-html="$t('campaignTargeting.title')"></h2>
        <p v-html="$t('campaignTargeting.description')"></p>
      </div>
      <div class="campaign-body">
        <div class="campaign-selection">
          <button class="channel disabled"
                  disabled="true"
                  :class="{ selected: channel }"
                  @click="setCampaign('channel')">
            <span class="name"
                  v-html="$t('campaignTargeting.channel.name')"></span>
            <span v-if="channel"
                  class="count">
              <span class="check">
                <i class="icon icon--check-white"></i>
              </span>
            </span>
          </button>
          <button class="cid"
                  :class="{ selected: cid }"
                  @click="setCampaign('cid')">
            <span class="name"
                  v-html="$t('campaignTargeting.cid.name')"></span>
            <span v-if="cid"
                  class="count">
              <span class="check">
                <i class="icon icon--check-white"></i>
              </span>
            </span>
          </button>
          <button class="utm"
                  :class="{ selected: utm }"
                  @click="setCampaign('utm')">
            <span class="name"
                  v-html="$t('campaignTargeting.utm.name')"></span>
            <span v-if="utm"
                  class="count">
              <span class="check">
                <i class="icon icon--check-white"></i>
              </span>
            </span>
          </button>
        </div>
        <div class="campaign-description">
          <p v-html="$t('campaignTargeting.onlyOne')"></p>
        </div>
      </div>

      <div class="campaign-footer">
        <ui-button @click="onCloseLayer(false)">{{ $t('common.close') }}</ui-button>
      </div>
    </div>

    <channel v-else-if="selecting === 'channel'"
         :aid="aid"
         :startDate="startDate"
         :endDate="endDate"
         :channelCache="channel"
         :otherKeySet="!!(cid || utm)"
         @onSetChannel="onSetChannel($event)"
         @onCloseLayer="onCloseLayer" />

    <cid v-else-if="selecting === 'cid'"
         :aid="aid"
         :startDate="startDate"
         :endDate="endDate"
         :cidCache="cid"
         :otherKeySet="!!(channel || utm)"
         @onSetCid="onSetCid($event)"
         @onCloseLayer="onCloseLayer" />

    <utm v-else-if="selecting === 'utm'"
         :aid="aid"
         :startDate="startDate"
         :endDate="endDate"
         :utmCache="utm"
         :otherKeySet="!!(cid || channel)"
         @onSetUtm="onSetUtm($event)"
         @onCloseLayer="onCloseLayer" />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'

import UiButton from '@/components/ui/UiButton'
import Channel from '@/components/report/campaign-targeting/Channel'
import Cid from '@/components/report/campaign-targeting/Cid'
import Utm from '@/components/report/campaign-targeting/Utm'

export default {
  name: 'CampaignTargeting',
  components: {
    UiButton,
    Channel,
    Cid,
    Utm
  },
  props: ['aid', 'startDate', 'endDate', 'campaign', 'utmCache', 'cidCache', 'channelCache'],
  methods: {
    onSetUtm (utm) {
      if (utm) {
        for (let key of Object.keys(utm)) {
          if (utm[key] && utm[key].length < 1) {
            delete utm[key]
          }
        }
        this.channel = null
        this.cid = null
      }
      this.utm = utm
      this.selecting = false
    },
    onSetCid (cid) {
      if (cid) {
        for (let key of Object.keys(cid)) {
          if (cid[key] && cid[key].length < 1) {
            delete cid[key]
          }
        }
        this.channel = null
        this.utm = null
      }
      this.cid = cid
      this.selecting = false
    },
    onSetChannel (channel) {
      if (channel) {
        for (let key of Object.keys(channel)) {
          if (channel[key] && channel[key].length < 1) {
            delete channel[key]
          }
        }
        this.cid = null
        this.utm = null
      }
      this.channel = channel
      this.selecting = false
    },
    setCampaign (type) {
      this.selecting = type
    },
    onCloseLayer () {
      this.$emit('onClose')
      let campaignChanged = false
      let campaign = {
        channel: null,
        cid: null,
        utm: null
      }
      if (JSON.stringify(this.channel) !== JSON.stringify(this.campaign ? this.campaign.channel : null)) {
        campaignChanged = true
        campaign.channel = this.channel
      }
      if (JSON.stringify(this.cid) !== JSON.stringify(this.campaign ? this.campaign.cid : null)) {
        campaignChanged = true
        campaign.cid = this.cid
      }
      if (JSON.stringify(this.utm) !== JSON.stringify(this.campaign ? this.campaign.utm : null)) {
        campaignChanged = true
        campaign.utm = this.utm
      }
      if (!campaign.channel && !campaign.cid && !campaign.utm) {
        campaign = null
      }
      if (campaignChanged) {
        EventBus.$emit('onCampaignChange', campaign)
      }
    }
  },
  created () {
    this.utm = this.campaign ? this.campaign.utm : this.utmCache
    this.cid = this.campaign ? this.campaign.cid : this.cidCache
    this.channel = this.campaign ? this.campaign.channel : this.channelCache
  },
  computed: {
  },
  data () {
    return {
      selecting: false,
      channel: null,
      cid: null,
      utm: null
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-targeting {
  .step {
    @include positionXYcenter;
    width: 731px;
    height: 526px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 15px;
    opacity: 1;

    .campaign-header {
      margin: 0 30px;
      border-bottom: 1px solid #bbbbbb;
      text-align: center;

      h2 {
        font-size: 20px;
        color: #444444;
        margin: 39px 0 15px;
      }

      p {
        font-size: 13px;
        line-height: 1.08;
        color: #888888;
        margin: 11px 0 30px;
      }
    }

    .campaign-body {
      margin: 0 30px;

      .campaign-selection {
        text-align: center;
        margin: 57px 0 5px;
        white-space: normal;

        button {
          position: relative;
          vertical-align: top;
          width: 172px;
          height: 172px;
          margin: 1px 10px;
          border: 2px solid #afafaf;
          border-radius: 13px;
          transition: border-color 0.2s ease,
                      background-color 0.2s ease,
                      box-shadow 0.2s ease;
          background-repeat: no-repeat;
          background-position: center calc(50% - 12px);

          &.disabled {
            opacity: 0.15;
            cursor: default;
          }

          &.channel {
            background-image: url(../../../assets/img/campaign-samsung.svg);
          }

          &.cid {
            background-image: url(../../../assets/img/campaign-cid.png);
            background-size: 49px 49px;
          }

          &.utm {
            background-image: url(../../../assets/img/campaign-utm.svg);
          }

          .name {
            font-size: 16px;
            color: #444444;
            display: block;
            margin-top: 70px;
          }

          .count {
            .check {
              position: absolute;
              top: -1px;
              right: -1px;
              width: 19px;
              height: 19px;
              padding: 4px 4px 16px 16px;
              border-top-right-radius: 10px;
              background: url('../../../assets/img/campaign-button-bg.svg') transparent no-repeat right -30px top -30px;
              transition: background-position 0.15s ease;

              i {
                width: 16px;
                height: 16px;
              }
            }
          }

          i {
            width: 20px;
            height: 20px;
          }

          &.selected {
            border: 2px solid #3eaa08;
            background-color: rgba(62, 170, 8, 0.03);

            .count {
              .check {
                background-position: right 0 top 0;
              }
            }
          }

          &:hover:not(.disabled) {
            border: 2px solid #0274ff;
            background-color: #ffffff;
            box-shadow: 0 8px 12px -2px rgba(0, 0, 0, 0.25);

            .count {
              .check {
                background-position: right -30px top -30px;
              }
            }
          }
        }
      }

      .campaign-description {
        position: relative;
        margin-top: 43px;
        text-align: center;

        p {
          font-size: 13px;
          color: #ec0047;
          line-height: 1.38;
        }
      }
    }

    .campaign-footer {
      margin: 53px 0 20px;
      text-align: center;

      .ui-btn {
        width: 95px;
      }
    }
  }
}
</style>
